<template>
    <div class="breadcrumbs-container">
        <el-page-header title="返回" v-if="isShowPageHeader" @back="handleBack"/>
        <el-breadcrumb class="app-breadcrumb" separator="|">
            <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noRedirect'|| index===levelList.length-1"
              class="no-redirect">{{ item.meta.title }}</span>
                <a v-else @click.prevent="handleLink(item)" style="text-decoration: none">{{ item.meta.title }}</a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
import { compile } from "path-to-regexp"

export default {
    name: "Breadcrumb",
    data() {
        return {
            levelList: null
        }
    },
    watch: {
        $route(route) {
            // if you go to the redirect page, do not update the breadcrumbs
            if (route.path.startsWith("/redirect/")) {
                return
            }
            this.getBreadcrumb()
        }
    },
    props: {
        isShowPageHeader: {
            type: Boolean,
            default: true
        },
        onBack: {
            type: Function
        }
    },
    created() {
        this.getBreadcrumb()
    },
    methods: {
        getBreadcrumb() {
            // only show routes with meta.title
            let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
            this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        },
        pathCompile(path) {
            // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
            const { params } = this.$route
            const toPath = compile(path)
            return toPath(params)
        },
        handleLink(item) {
            const {
                redirect,
                path
            } = item
            if (redirect) {
                this.$router.push(redirect)
                return
            }
            this.$router.push(this.pathCompile(path))
        },
        handleBack () {
            const fn = () => this.$router.go(-1)
            if (typeof this.onBack === "function") {
                this.onBack(fn)
            } else {
                fn()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.breadcrumbs-container {
    display: flex;
    align-items: center;
}
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 16px;
    line-height: 50px;
    margin-left: 8px;

    .no-redirect {
        color: #97a8be;
        cursor: text;
        font-size: 16px;
    }
}
</style>
